import React from 'react'

export default React.createContext({
  nativeapp: false,
  webview: false,
  locale: {},
  products: undefined
})
